import waitForElement from '../helpers/wait-for-element';

function ageGate() {
  
  //a basic validation to ensure all the field are filled before activating the SUBMIT button.
  var monthInput = jQuery('input[aria-label="MM"]');
  var dayInput = jQuery('input[aria-label="DD"]');
  var yearInput = jQuery('input[aria-label="YYYY"]');

  yearInput.on('keyup', function () {
    var val = jQuery(this).val();
    console.log(val);
    window.localStorage.setItem('user_year', val);
  });

  monthInput.on('keyup', function () {
    var val = jQuery(this).val();
    console.log(val);
    window.localStorage.setItem('user_month', val);
  });

  dayInput.on('keyup', function () {
    var val = jQuery(this).val();
    console.log(val);
    window.localStorage.setItem('user_day', val);
  });
}

export default ageGate;
